<template>
  <ul v-if="hasContent" class="bullet-text">
    <li v-for="(line, idx) in lines" :key="idx" class="whitespace-pre-line" :class="[BULLET_ITEM_CLASS, { 'mt-1': idx > 0 }]">
      {{ line }}
    </li>
  </ul>
</template>

<script lang="ts" setup>
/**
 * 一般輸入框（純文字）欄位的統一條列顯示。
 * - 吃 string（自動依 \n 斷行）或 string[]
 * - 非空白行 → bullet 項目（純文字，不解析 HTML）
 * - 空 / 純空白行 → 直接刪除
 * - 列點間距 4px
 */
interface Props {
  content?: string | string[] | null
}

// 復用 ETG 既有的灰點樣式（:before 灰點）
const BULLET_ITEM_CLASS =
  "relative pl-5 before:content-[''] before:inline-block before:absolute before:left-1 before:top-2 before:align-middle before:size-1 before:bg-black-80 before:rounded-full"

const props = defineProps<Props>()

const lines = computed<string[]>(() => {
  const raw = props.content ?? ''
  const list = Array.isArray(raw) ? raw : raw.split('\n')

  return list.map(item => `${item ?? ''}`.trim()).filter(text => text !== '')
})
const hasContent = computed(() => lines.value.length > 0)
</script>
